export default [
    {
		path: "/settings",
		component: () => import("../views/Settings/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/general",
		component: () => import("../views/Settings/General.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/retryrequests",
		component: () => import("../views/Settings/RetryRequests.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/maintenancemode",
		component: () => import("../views/Settings/MaintenanceMode.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/languageoverrides",
		component: () => import("../views/Settings/LanguageOverrides.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/configuration",
		component: () => import("../views/Settings/Configuration.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/settings/change-password",
		component: () => import("../views/Settings/ChangePassword.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/tagmanager",
		component: () => import("../views/Settings/Tags/TagManager.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/tag/:tagid?",
		component: () => import("../views/Settings/Tags/Tag.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/taggroups",
		component: () => import("../views/Settings/Tags/TagGroups.vue"),
	},
	{
		path: "/settings/taggroups/:tagGroupId",
		component: () => import("../views/Settings/Tags/GroupManager.vue")
	},
    {
		path: "/settings/reports/dataelements",
		component: () => import("../views/Settings/Reports/DataElements/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/reports/dataelements/edit/:dataelementid?",
		component: () => import("../views/Settings/Reports/DataElements/Edit.vue"),
	},
    {
		path: "/settings/reports/config",
		component: () => import("../views/Settings/Reports/Config/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/reports/config/edit/:reportconfigid?",
		component: () => import("../views/Settings/Reports/Config/Edit.vue")
	},
	{
		path: "/settings/competencytests",
		component: () => import("../views/Settings/CompetencyTests/Tests/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/competencytests/edit/:testid?",
		component: () => import("../views/Settings/CompetencyTests/Tests/Edit.vue"),
	},
	{
		path: "/settings/competencytests/filters",
		component: () => import("../views/Settings/CompetencyTests/Filters/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/competencytests/filters/edit/:filterid?",
		component: () => import("../views/Settings/CompetencyTests/Filters/Edit.vue"),
	},
	{
		path: "/settings/workbooks",
		component: () => import("../views/Settings/Workbooks/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/workbooks/item/:workbookid?",
		component: () => import("../views/Settings/Workbooks/Item.vue"),
	},
	{
		path: "/settings/interfaceeditor/procedures",
		component: () => import("../views/Settings/InterfaceEditor/Procedures/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/interfaceeditor/procedures/edit/:itemid?",
		component: () => import("../views/Settings/InterfaceEditor/Procedures/Edit.vue"),
	},
	{
		path: "/settings/interfaceeditor/sections",
		component: () => import("../views/Settings/InterfaceEditor/Sections/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/interfaceeditor/sections/edit/:itemid?",
		component: () => import("../views/Settings/InterfaceEditor/Sections/Edit.vue"),
	},
	{
		path: "/settings/grouptypes",
		component: () => import("../views/Settings/GroupTypes/Home.vue"),
	},
	{
		path: "/settings/grouptypes/:id",
		component: () => import("../views/Settings/GroupTypes/EditType.vue"),
	},
	{
		path: "/settings/grouptypes/:typeId/groups/:groupId",
		component: () => import("../views/Settings/GroupTypes/YearGroups/EditGroup.vue"),
	}
]
